/* tslint:disable */
/* eslint-disable */
/**
 * Vantis.HR.HttpApi.Host
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var EventTriggerType;
(function (EventTriggerType) {
    EventTriggerType[EventTriggerType["NUMBER_0"] = 0] = "NUMBER_0";
    EventTriggerType[EventTriggerType["NUMBER_1"] = 1] = "NUMBER_1";
})(EventTriggerType || (EventTriggerType = {}));
